import type { FC } from 'react';
import { Loading } from './Loading';

export const LoadingInline: FC = () => <Loading isInline />;
LoadingInline.displayName = 'LoadingInline';
